import { render, staticRenderFns } from "./AICrudTable.vue?vue&type=template&id=cf2ccabc&scoped=true"
import script from "./AICrudTable.vue?vue&type=script&lang=js"
export * from "./AICrudTable.vue?vue&type=script&lang=js"
import style0 from "./AICrudTable.vue?vue&type=style&index=0&id=cf2ccabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_tjpztcs3aockkrmwoqc6dtxv4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2ccabc",
  null
  
)

export default component.exports